import React from 'react'
import KnowledgeHubSearch from './search/knowledge-hub'
import {
  SignIn,
  SignedIn,
  SignedOut,
  UserButton
} from 'gatsby-plugin-clerk'

const searchIndices = [
  { name: `Internal Resources`, title: `Internal Resources` },
]

export default function InternalResources({ props, location, children }) {
  const heading = props?.heading
  return (
    <section className={`${children ? "" : "bg-blue-50"} p-section-half internal-resources`}>
      <div className={`${children ? "" : "container"}`}>
        <SignedIn redirectUrl={location.pathname} signUpUrl={'/internal-resources/sign-up/'}>
          <div className={`${children ? "container mb-4" : "mb-6"} flex justify-end`}><UserButton /></div>
          {children ? children : <KnowledgeHubSearch indices={searchIndices} heading={heading} location={location} />}
        </SignedIn>
        <SignedOut>
          <div className={`flex justify-center ${children ? "container" : ""}`}>
            <SignIn appearance={{
              variables: {
                colorPrimary: '#29688D',
                fontFamily: '"Roboto", "sans-serif"'
              },
              elements: {
                formButtonPrimary: 'btn btn-primary text-base font-normal',
              }
            }}
              redirectUrl={location.pathname}
            />
          </div>
        </SignedOut>
      </div>
    </section>
  )
}
